<template>
  <div class="card-item-wrapper p-d-12">
    <div class="card-item" :class="isDetail ? 'detail' : ''">
      <div>
        <div class="top-card card_header">
          <div class="f-semi f-16 f-c-black" v-if="!isSearch">{{ dataId }}</div>
          <div class="f-semi f-16 f-c-black" v-else v-html="searchHighlight(dataId, keySearch)"></div>
					<span class="spinner-border spinner-border-sm f-c-midgrey " role="status" aria-hidden="true" v-if="pageSetting.loading" />
					<template v-else>
						<div v-if="!isDetail" class="card-menu-vertical"></div>
					</template>
        </div>

        <div class="f-regular f-13 f-c-midgrey m-t-4 card_body">
          <label class="customer-name m-d-4 d-block">
            <img src="@/assets/icons/mood-happy.svg" alt="" class="m-r-4" style="height: 13px; margin-top: -2px" />
            <span v-if="!isSearch">{{ data.nama_konsumen }}</span>
            <span v-else v-html="searchHighlight(data.nama_konsumen, keySearch)" class="f-c-black"></span>
          </label>
          <label class="oulet-detail m-d-4 d-block">
            <img src="@/assets/icons/file.svg" alt="" class="m-r-4" style="height: 13px; margin-top: -2px" />
            <span>{{ data.jenis_transaksi_formated }}</span>

            <img
              src="@/assets/icon-sidebar/outlet-sidebar.svg"
              alt=""
              class="m-r-4 p-l-8"
              style="height: 13px; margin-top: -2px"
            />
            <span v-if="!isSearch">{{ data.nama_outlet }}</span>
            <span class="f-c-black" v-else v-html="searchHighlight(data.nama_outlet, keySearch)"></span>
          </label>
          <label class="customer m-d-4 d-block f-cont p-r-8">
            Dibuat <span>{{ $moment(data.waktu_pembuatan_raw).format("DD MMM YYYY HH:mm") }}</span>
            <span v-if="!isOwner"> oleh </span>
            <span>{{ data.nama_karyawan_transaksi }}</span>
          </label>
          <div
            v-if="!isDetail && !isOwner"
            :id="`card_footer${dataId}`"
            class="employee card_footer f-12 f-c-black f-regular m-x-min"
            :class="isConfirmed ? 'confirmed' : 'pending'"
          >
            Diminta <span>{{ data.nama_karyawan_penghapusan }}</span> (<span>{{ $moment(data.waktu_permintaan_raw).format("DD MMM YYYY HH:mm") }}</span
            >)
            <span class="confirmed approved" v-if="isConfirmed && isApproved">Disetujui</span>
            <span class="confirmed decline" v-if="isConfirmed && isDecline">Ditolak</span>
          </div>
          <div
            v-if="!isDetail && isOwner && isConfirmed"
            :id="`card_footer_owner${dataId}`"
            class="employee card_footer f-12 f-c-black f-regular m-x-min confirmed"
          >
            Dihapus oleh owner (<span>{{      }}</span
            >)
          </div>
          <div v-if="isDetail" class="detail-footer p-0 m-0">
            <span class="f-14 f-c-black f-regular">{{ data.harga_total | currency }}</span>
            <router-link
              :to="{
                name: 'TransaksiDetail',
                params: { idtransaksi: dataId },
              }"
              v-if="!isApproved && validateAccess('transactionRegular.read')"
            >
              <button type="button" class="btn p-0 btn-link">
                <span class="f-14 f-semi f-c-blue p-r-8">Lihat detail</span>
                <img src="@/assets/icons/arrow-right.svg" style="margin-left: 2px; margin-bottom: 3px" />
              </button>
            </router-link>
            <span v-if="isApproved" class="f-14 f-regular f-c-midgrey float-right">Nota Terhapus</span>
          </div>
          <!-- Drop Down Button -->
          <div
            v-if="!isDetail"
            class="clik"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            @click="savePointer"
          />
          <div v-if="!isDetail" class="dropdown-menu garis-listkomisi border-0 p-0">
            <router-link
              :to="{
                name: 'PembatalanTransaksiReguler.detail.data',
                params: { id: data.idhapus },
              }"
              v-if="validateAccess('deleteRegular.read')"
            >
              <button class="dropdown-item icon-2 b-d" style="min-width: 140px" @click="smartTrackingClick('detail_penghapusan_transaksi_reguler') ">
                <span class="mar-right-10">
                  <img src="@/assets/icons/file-text.svg" />
                </span>
                Detail
              </button>
            </router-link>
            <button class="dropdown-item icon-2 b-d" v-if="!isConfirmed && validateAccess('deleteRegular.confirm')" @click="setApproved">
              <span class="mar-right-10">
                <img src="@/assets/icons/check.svg" />
              </span>
              Setujui
            </button>
            <button class="dropdown-item icon-2" v-if="!isConfirmed && validateAccess('deleteRegular.confirm')" @click="setDecline">
              <span class="mar-right-10">
                <img src="@/assets/icons/x.svg" />
              </span>
              Tolak
            </button>
          </div>
        </div>
      </div>
    </div>
		<TransaksiModalHapus
			v-if="pageSetting.modal.deleteTransaksi && detailTransaksi"
			:transaksi="detailTransaksi"
			@close="
				() => {
					pageSetting.modal.deleteTransaksi = false;
				}
			"
		/>
		<SOTerimaModal
			v-if="pageSetting.modal.penghapusan.setujui"
			:use-route-push="false"
			@close="
				() => {
					pageSetting.modal.penghapusan.setujui = false;
				}
			"
		/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state.js";
import TransaksiModalHapus from "@/modules/transaksi-global/transaksi-reguler/views/modal/TransaksiModalHapus.vue";
import SOTerimaModal from "./SOTerimaModal.vue";

export default {
  name: "SOCardItem",
  props: {
    data: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
	components: {
		TransaksiModalHapus,
		SOTerimaModal,
	},
	data() {
		return {
			detailTransaksi: null,
			exceptionPembatalanTransaksi: [3, 11],
      pageSetting: {
        loading: false,
        modal: {
          deleteTransaksi: false,
          penghapusan: {
            setujui: false,
            tolak: false,
          },
        },
      },
		}
	},
  computed: {
    ...mapGetters(moduleName, {
      search: "search",
    }),
		...mapGetters("transaksiModule", {
      detail: "getDetailTransaksi",
    }),
    isSearch() {
      return this.search.onSearch;
    },
    keySearch() {
      return this.search.key;
    },
    dataId() {
      return this.data.idtransaksi;
    },
    queryList() {
      return this.$route.query;
    },
    isOwner() {
      return this.data.isrequestkaryawan === 0 && !this.data.idkaryawan_penghapusan;
    },
    isConfirmed() {
      return this.data.status_penghapusan !== 0;
    },
    isApproved() {
      return this.data.status_penghapusan === 1;
    },
    isDecline() {
      return this.data.status_penghapusan === 2;
    },
  },
  methods: {
    ...mapActions({
      updatePointer: `${moduleName}/saveScrollPosition`,
      storeDataDetail: `${moduleName}/storeDataDetail`,
    }),
    savePointer(e) {
      this.updatePointer(e.pageY);
    },
		async getDetailTransaksi() {
			return new Promise(async (resolve, reject) => {
				this.pageSetting.loading = true
				const res = await this.$store.dispatch(
					"transaksiModule/fetchDetailTransaksi",
					this.data.idtransaksi
				);
				this.pageSetting.loading = false
				if (!res.success) {
					this.$toast.error(res.err);
					this.$router.back();
					reject()
				}
				this.detailTransaksi = this.detail.data
				resolve()
			})
    },
    async setApproved() {
			if (!this.detailTransaksi) {
				await this.getDetailTransaksi()
			}
      await this.storeDataDetail({ data: this.data });
			if (!this.detailTransaksi) return;
      let isException = false;

			// cek pembayaran apakah terdapat edc atau debit, jika iya maka pakai modal.deleteTransaksi
      this.detailTransaksi.rincian_pembayaran.forEach((v) => { 
        if (this.exceptionPembatalanTransaksi.includes(v.jenis_bayar)) {
          isException = true;
        }
      });
      if (isException) {
        this.pageSetting.modal.deleteTransaksi = true;
      } else {
        this.pageSetting.modal.penghapusan.setujui = true;
      }
      this.smartTrackingClick("setuju_hapus_transaksi_reguler");

    },
    async setDecline() {
      await this.storeDataDetail({ data: this.data });
      await this.$router.push({
        name: "PembatalanTransaksiReguler.tolak",
      });
      this.smartTrackingClick("tolak_hapus_transaksi_reguler");

    },
  },
};
</script>

<style scoped>
.p-r-8 {
  padding-right: 8px;
}
.detail {
  border: 1px solid #c8d0dd;
}

.detail-footer button {
  float: right;
}

.detail-footer button span {
  padding-right: 5px;
}

.card-item .employee,
.detail .detail-footer {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  margin: 10px -18px -10px -18px !important;
  padding: 8px 18px !important;
  box-shadow: inset 0px 1px 0px #ededed, inset 0px -1px 0px #ededed;
}

.card-item div.pending {
  background: linear-gradient(90deg, #fff8e1 0%, #ffffff 100%), linear-gradient(90deg, #e8fcee 0%, #ffffff 100%);
}

.card-item div.confirmed {
  background: white;
}

div.employee span.confirmed {
  float: right;
  padding: 2px 8px;
  border-radius: 55px;
}

div.employee span.approved {
  background: #effaf1;
}

div.employee span.decline {
  background: #faefef;
}
</style>
